// extracted by mini-css-extract-plugin
module.exports = {"ingress__container":"Inngress_ingress__container__N3HBz","links":"Inngress_links__LzpAI","intro":"Inngress_intro__T3If4"};